module.exports = __webpack_public_path__ + "static/media/btn_up.68884b36.svg";